export const 
    OAUTH_CONNECTIONS_LOAD_REQ      = 'OAUTH_CONNECTIONS_LOAD_REQ',
    OAUTH_CONNECTIONS_LOAD_SUCCESS  = 'OAUTH_CONNECTIONS_LOAD_SUCCESS',
    OAUTH_CONNECTIONS_LOAD_ERROR    = 'OAUTH_CONNECTIONS_LOAD_ERROR',

    OAUTH_MY_LOAD_REQ               = 'OAUTH_MY_LOAD_REQ',
    OAUTH_MY_LOAD_SUCCESS           = 'OAUTH_MY_LOAD_SUCCESS',
    OAUTH_MY_LOAD_ERROR             = 'OAUTH_MY_LOAD_ERROR',

    OAUTH_CLIENT_CREATE_REQ         = 'OAUTH_CLIENT_CREATE_REQ',
    OAUTH_CLIENT_CREATE_SUCCESS     = 'OAUTH_CLIENT_CREATE_SUCCESS',
    OAUTH_CLIENT_CREATE_ERROR       = 'OAUTH_CLIENT_CREATE_ERROR',

    OAUTH_CLIENT_UPDATE_REQ         = 'OAUTH_CLIENT_UPDATE_REQ',
    OAUTH_CLIENT_UPDATE_SUCCESS     = 'OAUTH_CLIENT_UPDATE_SUCCESS',
    OAUTH_CLIENT_UPDATE_ERROR       = 'OAUTH_CLIENT_UPDATE_ERROR',

    OAUTH_CLIENT_REVOKE_REQ         = 'OAUTH_CLIENT_REVOKE_REQ',
    OAUTH_CLIENT_REVOKE_SUCCESS     = 'OAUTH_CLIENT_REVOKE_SUCCESS',
    OAUTH_CLIENT_REVOKE_ERROR       = 'OAUTH_CLIENT_REVOKE_ERROR',

    OAUTH_CLIENT_REMOVE_REQ         = 'OAUTH_CLIENT_REMOVE_REQ',
    OAUTH_CLIENT_REMOVE_SUCCESS     = 'OAUTH_CLIENT_REMOVE_SUCCESS',
    OAUTH_CLIENT_REMOVE_ERROR       = 'OAUTH_CLIENT_REMOVE_ERROR',

    OAUTH_CLIENT_ICON_UPLOAD_REQ            = 'OAUTH_CLIENT_ICON_UPLOAD_REQ',
    OAUTH_CLIENT_ICON_UPLOAD_SUCCESS        = 'OAUTH_CLIENT_ICON_UPLOAD_SUCCESS',
    OAUTH_CLIENT_ICON_UPLOAD_ERROR          = 'OAUTH_CLIENT_ICON_UPLOAD_ERROR',

    OAUTH_CLIENT_RESET_SECRET_REQ           = 'OAUTH_CLIENT_RESET_SECRET_REQ',
    OAUTH_CLIENT_RESET_SECRET_SUCCESS       = 'OAUTH_CLIENT_RESET_SECRET_SUCCESS',
    OAUTH_CLIENT_RESET_SECRET_ERROR         = 'OAUTH_CLIENT_RESET_SECRET_ERROR',

    OAUTH_CLIENT_TEST_TOKEN_LOAD_REQ        = 'OAUTH_CLIENT_TEST_TOKEN_LOAD_REQ',
    OAUTH_CLIENT_TEST_TOKEN_LOAD_SUCCESS    = 'OAUTH_CLIENT_TEST_TOKEN_LOAD_SUCCESS',
    OAUTH_CLIENT_TEST_TOKEN_LOAD_ERROR      = 'OAUTH_CLIENT_TEST_TOKEN_LOAD_ERROR',

    OAUTH_CLIENT_TEST_TOKEN_CREATE_REQ      = 'OAUTH_CLIENT_TEST_TOKEN_CREATE_REQ',
    OAUTH_CLIENT_TEST_TOKEN_CREATE_SUCCESS  = 'OAUTH_CLIENT_TEST_TOKEN_CREATE_SUCCESS',
    OAUTH_CLIENT_TEST_TOKEN_CREATE_ERROR    = 'OAUTH_CLIENT_TEST_TOKEN_CREATE_ERROR'